<template>
  <div class="blackList-box">
    <!--操作栏-->
    <div class="action-bar flex" style="align-items: baseline">
      <el-input
        v-model.number="params.uid"
        placeholder="请输入用户ID"
        size="small"
        clearable
        class="param-input"
      ></el-input>
      <el-select   size="small" clearable v-model="params.title">
        <el-option value="账号问题" label="账号问题"></el-option>
        <el-option value="影视资源" label="影视资源"></el-option>
        <el-option value="APP体验" label="APP体验"></el-option>
        <el-option value="播放失败" label="播放失败"></el-option>
        <el-option value="播放卡顿" label="播放卡顿"></el-option>
        <el-option value="分类有误" label="分类有误"></el-option>
        <el-option value="充值问题" label="充值问题"></el-option>
        <el-option value="其他" label="其他"></el-option>
      </el-select>
      <el-button type="primary" size="small" @click="search()"
        >搜索</el-button
      >
    </div>

    <!--表格数据-->
    <el-table
      :data="tableData"
      style="width: 100%"
      border
      size="small"
      v-loading="loading"
      element-loading-text="拼命加载中"
      element-loading-spinner="el-icon-loading"
      ref="multipleTable"
      height='650'
    >
      <el-table-column prop="id" label="ID" align="center" min-width="200">
        <template slot-scope="scope">
          <span>{{ scope.row.id || "未知" }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="uid" label="用户ID" align="center" min-width="120">
        <template slot-scope="scope">
          <span>{{ scope.row.uid || "未知" }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="title" label="问题类型" align="center" min-width="120"></el-table-column>
      <el-table-column
        prop="content"
        label="问题原因"
        align="center"
        min-width="340"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <span>{{ scope.row.content || "未知" }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="" label="问题图文" align="center">
        <template slot-scope="scope">
          <img-load :width="'60px'"  :src="imgUrl + scope.row.cover"></img-load>
        </template>
      </el-table-column>
      <el-table-column
        prop="version"
        label="版本号"
        align="center"
        min-width="160"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.version || "未知" }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="devType"
        label="设备型号"
        align="center"
        min-width="160"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.devType || "未知" }}</span>
        </template>
      </el-table-column>
      <el-table-column
          prop="replay"
          label="快捷回复"
          align="center"
          min-width="180"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.replay || "未知" }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="createdAt"
        label="创建时间"
        align="center"
        min-width="160"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.createdAt | changeDate }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="updatedAt"
        label="更新时间"
        align="center"
        min-width="160"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.updatedAt | changeDate }}</span>
        </template>
      </el-table-column>
      <el-table-column
        label="操作"
        align="center"
        fixed="right"
        min-width="200"
      >
        <template slot-scope="scope">
          <el-button
            type="success"
            size="mini"
            icon="el-icon-edit"
            @click="action(scope.row)"
            >编辑</el-button
          >
          <el-button
            type="danger"
            size="mini"
            icon="el-icon-delete"
            @click="remove(scope.row)"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>

    <!--分页组件-->
    <el-pagination
      :page-sizes="[10, 15, 20, 30]"
      :current-page="params.pageNumber"
      :page-size="params.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
      background
      v-if="total > 1"
      @size-change="changeSize"
      @current-change="changeCurrent"
    ></el-pagination>
    <!--编辑反馈信息弹窗-->
    <edit-feedback
      ref="editFeedback"
      @handlerAddblack="getFeedbackList"
    ></edit-feedback>
  </div>
</template>
<script>
import EditFeedback from "./components/editFeedback";
import API from "@/api";
import baseConfig from "@/utils/serverUrlConfig";
import {paramsFilter} from "@/utils/global";

export default {
  data() {
    return {
      // 表格数据加载动画
      loading: false,
      tableData: [],
      time: "",
      total: 0,
      imgUrl: baseConfig.imgUrl,
      // 反馈信息类型
      blackType: [
        {
          label: "IP",
          value: "IP",
        },
      ],
      // 用户管理列表请求参数
      params: {
        uid: "",
        title: "",
        pageNumber: 1,
        pageSize: 20,
      },
    };
  },
  components: {
    EditFeedback,
  },
  created() {
    this.getFeedbackList();
  },
  methods: {
    // 请求反馈信息列表
    getFeedbackList() {
      this.loading = true;
      var paramsFilter1 = paramsFilter(this.params);
      API.getFeedbackList(paramsFilter1)
        .then((res) => {
          if (res.code === 200 && res.data.list) {
            this.tableData = res.data.list;
            this.total = res.data.total;
          } else {
            this.tableData = [];
            this.total = 0;
          }
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },

    // 新增、修改tags
    action(type) {
      this.$refs.editFeedback.open(type);
    },
    // 删除
    remove(row) {
      this.$confirm("您确定要删除当前反馈信息吗？", "删除提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          API.delFeedback({ ids: [row.id] }).then((res) => {
            if (res.code === 200) {
              this.$message({
                message: "删除反馈信息成功",
                type: "success",
              });
              this.getFeedbackList();
            } else {
              this.$message.error("删除失败");
            }
          });
        })
        .catch(() => {});
    },

    // 搜索对应列表
    search() {
      this.params.pageNumber = 1;
      this.getFeedbackList();
    },
    // 监听新增成功回掉
    getAddblack() {
      this.getFeedbackList();
    },
    // pageSize发生变化触发
    changeSize(size) {
      this.params.pageSize = size;
      this.params.pageNumber = 1;
      this.getFeedbackList();
    },
    // 当前页发生变化触发
    changeCurrent(pageNumber) {
      this.params.pageNumber = pageNumber;
      this.getFeedbackList();
    },
  },
};
</script>
<style lang="scss">
</style>

